
export default function AboutValues() {
  const values = [
    {
      icon: 'ri-heart-line',
      title: 'Integrity',
      description: 'We operate with transparency, honesty, and ethical standards in every interaction and decision we make.'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Innovation',
      description: 'We continuously evolve our platform and services to meet the changing needs of modern businesses.'
    },
    {
      icon: 'ri-team-line',
      title: 'Collaboration',
      description: 'We believe in the power of partnerships and collective growth to achieve extraordinary results.'
    },
    {
      icon: 'ri-trophy-line',
      title: 'Excellence',
      description: 'We strive for the highest quality in everything we do, from our programs to our member experience.'
    },
    {
      icon: 'ri-global-line',
      title: 'Inclusivity',
      description: 'We welcome businesses from all backgrounds, industries, and stages of growth to join our community.'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Growth',
      description: 'We are committed to the continuous growth and success of our members and our platform.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Core Values
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            These fundamental principles guide our decisions, shape our culture, and define how we serve our global community of businesses.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${value.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">{value.title}</h3>
              <p className="text-gray-600 leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
